<template>
    <div class="loading-spinner text-center" role="status" aria-live="polite">
        <div class="spinner-container">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading AI response...</span>
            </div>
        </div>
        <div class="loading-text mt-2">
            <p class="mb-1">
                <i class="fas fa-brain"></i>
                {{ currentMessage }}
            </p>
            <small class="text-muted">{{ submessage }}</small>
        </div>

        <!-- Progress Dots -->
        <div class="progress-dots mt-2">
            <span class="dot" :class="{ active: dotIndex >= 0 }"></span>
            <span class="dot" :class="{ active: dotIndex >= 1 }"></span>
            <span class="dot" :class="{ active: dotIndex >= 2 }"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',

    data() {
        return {
            messageIndex: 0,
            dotIndex: 0,
            messageInterval: null,
            dotInterval: null,
            messages: [
                {
                    main: 'Analysing your question...',
                    sub: 'Understanding what you\'re asking about'
                },
                {
                    main: 'Searching knowledge base...',
                    sub: 'Looking through FAQs and event details'
                },
                {
                    main: 'Generating AI response...',
                    sub: 'Creating a personalised answer for you'
                },
                {
                    main: 'Almost ready...',
                    sub: 'Finalising your response'
                }
            ]
        }
    },

    computed: {
        currentMessage() {
            return (this.messages[this.messageIndex] && this.messages[this.messageIndex].main) || 'Processing...'
        },

        submessage() {
            return (this.messages[this.messageIndex] && this.messages[this.messageIndex].sub) || 'Please wait...'
        }
    },

    mounted() {
        this.startAnimations()
    },

    beforeDestroy() {
        this.stopAnimations()
    },

    methods: {
        startAnimations() {
            // Cycle through messages every 2 seconds
            this.messageInterval = setInterval(() => {
                this.messageIndex = (this.messageIndex + 1) % this.messages.length
            }, 2000)

            // Animate progress dots every 500ms
            this.dotInterval = setInterval(() => {
                this.dotIndex = (this.dotIndex + 1) % 4
            }, 500)
        },

        stopAnimations() {
            if (this.messageInterval) {
                clearInterval(this.messageInterval)
                this.messageInterval = null
            }

            if (this.dotInterval) {
                clearInterval(this.dotInterval)
                this.dotInterval = null
            }
        }
    }
}
</script>

<style scoped>
.loading-spinner {
    padding: 1rem 1rem;
}

.spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner-border {
    width: 2.5rem;
    height: 2.5rem;
    border-width: 0.25rem;
    border: 0.25rem solid rgba(0, 123, 255, 0.25);
    border-right-color: #007bff;
    border-radius: 50%;
    animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg);
    }
}

.loading-text {
    color: #6c757d;
}

.loading-text i {
    color: #007bff;
    margin-right: 0.5rem;
}

.progress-dots {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #dee2e6;
    transition: background-color 0.3s ease;
}

.dot.active {
    background-color: #007bff;
}

/* Accessible animations */
@media (prefers-reduced-motion: reduce) {
    .spinner-border {
        animation: none;
        border: 0.25rem solid #007bff;
        border-radius: 50%;
    }

    .dot {
        background-color: #007bff;
    }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
    .loading-text {
        color: #adb5bd;
    }

    .dot {
        background-color: #495057;
    }

    .dot.active {
        background-color: #0d6efd;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/AiAgents/FaqAgent/components/LoadingSpinner.vue